<!-- Accessible selectable item component with keyboard support -->
<div class="parent">
	<!-- Converted to button for better keyboard accessibility -->
	<button
		class="item-selectable-article"
		[class.selectedRed]="selected > 0 && customRemove"
		[class.selected]="selected > 0 && !customRemove"
		[attr.aria-pressed]="selected > 0"
		[attr.aria-label]="
			(article.name | langObservable | async).replace('---', '').replace('+++', '') +
			(price > 0 ? ' plus ' + numberToCurrency(price, currency) : '')
		"
		(click)="addItem()"
		tabindex="0"
	>
		<div class="item-content">
			<!-- Selection indicator -->
			<div class="selection-indicator" [class.active]="selected > 0" aria-hidden="true">
				<ion-icon class="selected_item_icon" [class.active]="selected > 0" src="../../../assets/dean_and_david/selected_item.svg">
				</ion-icon>
			</div>

			<div class="item-details">
				<!-- Price information with proper semantics -->
				<p *ngIf="price > 0" class="option-price" aria-live="polite">+{{ numberToCurrency(price, currency) }}</p>
				<p *ngIf="!price" class="option-price" aria-hidden="true"></p>

				<!-- Item image with improved alt text -->
				<div class="image-container">
					<ion-img
						*ngIf="article.assets.medium"
						[src]="article.assets.medium"
						[attr.alt]="'Image of ' + (article.name | langObservable | async).replace('---', '').replace('+++', '')"
						(ionError)="onError($event, article.assets.original)"
						class="item-selectable-article-image ion-no-margin ion-no-padding"
					>
					</ion-img>

					<ion-img
						*ngIf="!article.assets.medium"
						src="../../../assets/dean_and_david/logo.png"
						alt="Default logo"
						class="item-selectable-article-image ion-no-margin ion-no-padding"
					>
					</ion-img>
				</div>

				<!-- Item name -->
				<p class="name" id="item-name-{{ article._id }}">
					{{ (article.name | langObservable | async).replace('---', '').replace('+++', '') }}
				</p>
			</div>
		</div>

		<!-- Action buttons section -->
		<div class="wrapp">
			<!-- Add button -->
			@if (customRemove || customAdd) {
			} @else {
				<div class="add-button" *ngIf="selected == 0" aria-hidden="true" role="button" tabindex="0">
					<span>Add</span>
				</div>
			}

			<!-- Quantity selector with keyboard accessibility -->
			<div
				class="quantity-selector"
				*ngIf="selected >= 1 && group && group.hasMultiple && !isEmptyArticle && !customAdd && !customRemove"
				role="group"
				aria-label="Quantity selector"
			>
				<!-- Decrease quantity button -->
				<button
					class="quantity-btn decrease"
					(click)="remove.emit(); $event.stopPropagation()"
					aria-label="Decrease quantity"
					tabindex="0"
				>
					<ion-icon src="../../../assets/dean_and_david/minus.svg" aria-hidden="true"> </ion-icon>
				</button>

				<!-- Quantity display -->
				<p class="quantity" aria-live="polite">{{ selected }}</p>

				<!-- Increase quantity button -->
				<button
					class="quantity-btn increase"
					(click)="add.emit(); $event.stopPropagation()"
					aria-label="Increase quantity"
					tabindex="0"
				>
					<ion-icon src="../../../assets/dean_and_david/plus.svg" aria-hidden="true"> </ion-icon>
				</button>
			</div>
		</div>
	</button>
</div>
